module.exports = __webpack_public_path__ + "img/facebook-black.184a9310.svg";